/** 'male' / 'female' (atau label lama) -> 'Putra' / 'Putri'. */
export function labelJK(g) {
  const s = String(g || '').toLowerCase().trim();
  if (['male', 'l', 'putra', 'laki-laki', 'laki laki', 'pria'].includes(s)) return 'Putra';
  if (['female', 'p', 'putri', 'perempuan', 'wanita'].includes(s)) return 'Putri';
  return g || '-';
}

/** Urutan tampil: Putra dulu, lalu Putri; dalam satu jenis kelamin urut berat. */
export function urutPutraPutri(a, b) {
  const r = (x) => (labelJK(x.gender) === 'Putra' ? 0 : labelJK(x.gender) === 'Putri' ? 1 : 2);
  return r(a) - r(b) || Number(a.weight_min ?? 0) - Number(b.weight_min ?? 0);
}
